import { ref } from 'vue';

export default () => {
    const show = ref(false);
    const type = ref('add');
    const row = ref({});

    function open(t, r) {
        show.value = true;
        type.value = t || 'add';
        row.value = r || {};
    }

    function close() {
        show.value = false;
        type.value = 'add';
        row.value = {};
    }

    return { show, type, row, open, close }
}